<ng-container *transloco="let t">
    <div class="container">
        <div fxLayout="column" fxLayoutAlign="space-around start">
            <div fxLayout="row wrap" fxLayoutAlign="space-around start">
                <div
                    fxFlex="940px"
                    fxLayoutAlign="space-between center"
                    fxFlex.xs="55"
                >
                    <h2>{{ t("support.terms-of-use.title") }}</h2>
                </div>
                <div fxFlex="940px" fxLayoutAlign="start center" fxFlex.xs="55">
                    <p>{{ t("support.terms-of-use.sub-title") }}</p>
                </div>
            </div>

            <mat-tab-group animationDuration="0ms">
                <mat-tab>
                    <ng-container>
                        <mat-accordion multi="true">
                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel1.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel1.p1'
                                            )
                                        "
                                    ></p>
                                </ng-template>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel2.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel2.p1'
                                            )
                                        "
                                    ></p>
                                </ng-template>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel3.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel3.p1'
                                            )
                                        "
                                    ></p>
                                </ng-template>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel4.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p
                                    [innerHTML]="
                                        t(
                                            'support.terms-of-use.tabs.tab1.panels.panel4.p1'
                                        )
                                    "
                                ></p>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel5.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p
                                    [innerHTML]="
                                        t(
                                            'support.terms-of-use.tabs.tab1.panels.panel5.p1'
                                        )
                                    "
                                ></p>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel6.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p
                                    [innerHTML]="
                                        t(
                                            'support.terms-of-use.tabs.tab1.panels.panel6.p1'
                                        )
                                    "
                                ></p>
                            </mat-expansion-panel>

                            <mat-expansion-panel
                                (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            t(
                                                "support.terms-of-use.tabs.tab1.panels.panel7.title"
                                            )
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p
                                    [innerHTML]="
                                        t(
                                            'support.terms-of-use.tabs.tab1.panels.panel7.p1'
                                        )
                                    "
                                ></p>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>
